export const ACCOUNT_BILLING_EVENTS = Object.freeze({
  DASHBOARD_PAGE_VIEWED: {
    name: 'dashboard_page_viewed',
    category: 'Account',
    description: 'Dashboard 页面首次查看时触发',
    // 页面曝光类事件显式抬到 full 档（2026-10-27）：与 landing/auth 的 page_view 同口径。
    // 预算：声明峰值 10 + 5 + 1 = 16 ≪ 25，安全。
    globalsProfile: 'full',
    requiredParams: [],
    optionalParams: [
      'module_name', 'source_position', 'element_type', 'lang', 'is_logged_in',
      'current_tier_id', 'entitlement_kind', 'user_state', 'test_mode_enabled',
      'navigation_trigger'
    ]
  },
  DASHBOARD_SECTION_VIEWED: {
    name: 'dashboard_section_viewed',
    category: 'Account',
    description: 'Dashboard 内当前计划、使用统计或 Pricing 模块展示时触发',
    requiredParams: ['dashboard_section'],
    optionalParams: [
      'module_name', 'source_position', 'element_name', 'element_type',
      'dashboard_content_state', 'current_tier_id', 'entitlement_kind', 'user_state',
      'credits_cycle_limit', 'credits_cycle_used', 'credits_trial_total', 'credits_trial_used',
      'usage_percent_bucket', 'pricing_plan_count', 'billing_period'
    ]
  },
  DASHBOARD_STATUS_SYNC_COMPLETED: {
    name: 'dashboard_status_sync_completed',
    category: 'Account',
    description: 'Dashboard 订阅状态同步成功或失败时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'module_name', 'source_position', 'method', 'reason_code', 'http_status', 'duration_ms',
      'current_tier_id', 'entitlement_kind', 'user_state'
    ]
  },
  DASHBOARD_PRICING_LOAD_COMPLETED: {
    name: 'dashboard_pricing_load_completed',
    category: 'Billing',
    description: 'Dashboard Pricing plans 加载完成、为空或失败时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'module_name', 'source_position', 'reason_code', 'pricing_plan_count',
      'billing_period', 'dashboard_content_state'
    ]
  },
  DASHBOARD_OPTION_CHANGED: {
    name: 'dashboard_option_changed',
    category: 'Account',
    description: 'Dashboard 内配置项变化时触发，例如 Billing Period 切换',
    requiredParams: ['option_name', 'option_value'],
    optionalParams: [
      'module_name', 'source_position', 'element_name', 'element_type', 'method',
      'previous_value', 'billing_period'
    ]
  },
  DASHBOARD_CTA_CLICKED: {
    name: 'dashboard_cta_clicked',
    category: 'Billing',
    description: 'Dashboard Pricing CTA 点击或被本地 guard 阻断时触发',
    requiredParams: ['cta_type'],
    optionalParams: [
      'module_name', 'source_position', 'element_name', 'element_type', 'method',
      'action_status', 'reason_code', 'plan_id', 'billing_period', 'billing_flow',
      'content_id', 'content_type', 'current_tier_id', 'entitlement_kind', 'user_state',
      'is_current_plan', 'is_button_disabled', 'test_mode_enabled'
    ]
  },
  BILLING_SESSION_STARTED: {
    name: 'billing_session_started',
    category: 'Billing',
    description: '创建 checkout 或 portal session 前触发',
    requiredParams: ['billing_flow'],
    optionalParams: [
      'module_name', 'source_position', 'element_name', 'element_type', 'method',
      'request_id', 'plan_id', 'billing_period', 'current_tier_id', 'entitlement_kind'
    ]
  },
  BILLING_SESSION_COMPLETED: {
    name: 'billing_session_completed',
    category: 'Billing',
    description: 'checkout 或 portal session 创建成功、失败或被阻断后触发',
    requiredParams: ['billing_flow', 'action_status'],
    optionalParams: [
      'module_name', 'source_position', 'reason_code', 'error_code', 'http_status',
      'duration_ms', 'request_id', 'plan_id', 'billing_period', 'current_tier_id', 'entitlement_kind'
    ]
  },
  BILLING_EXTERNAL_REDIRECT_STARTED: {
    name: 'billing_external_redirect_started',
    category: 'Billing',
    description: '即将跳转 checkout 或 portal 外部页面前触发',
    requiredParams: ['billing_flow'],
    optionalParams: [
      'module_name', 'source_position', 'element_name', 'element_type', 'action_status',
      'request_id', 'plan_id', 'billing_period'
    ]
  },
  BILLING_CHECKOUT_RETURN_DETECTED: {
    name: 'billing_checkout_return_detected',
    category: 'Billing',
    description: 'Dashboard 识别到 checkout return query 时触发',
    requiredParams: ['checkout_mode'],
    optionalParams: [
      'module_name', 'source_position', 'billing_flow', 'return_query_present', 'lang'
    ]
  },
  BILLING_CHECKOUT_RETURN_COMPLETED: {
    name: 'billing_checkout_return_completed',
    category: 'Billing',
    description: 'Dashboard checkout return 处理完成或失败时触发',
    requiredParams: ['checkout_mode', 'action_status'],
    optionalParams: [
      'module_name', 'source_position', 'billing_flow', 'reason_code', 'http_status',
      'duration_ms', 'current_tier_id', 'entitlement_kind', 'user_state', 'return_query_present'
    ]
  },
  BILLING_CHECKOUT_CONFIRM_COMPLETED: {
    name: 'billing_checkout_confirm_completed',
    category: 'Billing',
    description: 'one-off checkout confirm 完成、失败或被阻断时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'module_name', 'source_position', 'billing_flow', 'checkout_mode', 'reason_code',
      'http_status', 'duration_ms', 'current_tier_id', 'entitlement_kind'
    ]
  },
  BILLING_NOTICE_VIEWED: {
    name: 'billing_notice_viewed',
    category: 'Billing',
    description: 'Billing Notice 弹窗展示时触发',
    requiredParams: [],
    optionalParams: [
      'module_name', 'source_position', 'element_name', 'element_type', 'content_type',
      'reason_code', 'target_route_name',
      // 0.9.6.7：与 reason_code（动作语义）分离的「弹窗类型」
      'notice_reason_code'
    ],
    reasonCodeValues: [
      'one_off_expiring', 'low_credits', 'insufficient_credits',
      // v2.1.13 新增：首次积分发放弹窗 / 未消费提醒
      'trial_credits_granted', 'credit_reminder'
    ]
  },
  BILLING_NOTICE_ACTION_CLICKED: {
    name: 'billing_notice_action_clicked',
    category: 'Billing',
    description: 'Billing Notice 弹窗按钮或关闭动作点击时触发',
    requiredParams: ['cta_type'],
    optionalParams: [
      'module_name', 'source_position', 'element_name', 'element_type', 'method',
      'action_status', 'reason_code', 'target_route_name',
      'notice_reason_code'
    ],
    reasonCodeValues: [
      'one_off_expiring', 'low_credits', 'insufficient_credits',
      // v2.1.13 新增：首次积分发放弹窗 / 未消费提醒
      'trial_credits_granted', 'credit_reminder'
    ]
  },

  // ⚠️ 2026-10-27 补 `sub_feature_code`：此前只报父模块（compare / result_guide /
  // atomic_capability），GA 里分不清被锁的是 point_inspector 还是 finetune_slider。
  // 预算：自有 4（含条件键）= full 档，峰值 4+5+1 = 10 ≪ 25。
  FEATURE_GATE_SHOWN: {
    name: 'feature_gate_shown',
    category: 'Billing',
    description: '功能门禁曝光时触发',
    requiredParams: [],
    optionalParams: ['feature_code', 'sub_feature_code', 'gate_mode', 'required_tier']
  },
  // `gate_mode` 口径 = decision.availability（与 feature_gate_shown 同一取值域），
  // 2026-10-27 前的调用方硬编码 `paid_upgrade`（不在 availability 取值域内）⇒ 两事件无法关联。
  FEATURE_GATE_CTA_CLICKED: {
    name: 'feature_gate_cta_clicked',
    category: 'Billing',
    description: '功能门禁CTA点击时触发',
    requiredParams: [],
    optionalParams: ['feature_code', 'sub_feature_code', 'gate_mode', 'cta_type']
  },
  CREDIT_ACTION_FAILED: {
    name: 'credit_action_failed',
    category: 'Billing',
    description: 'Credit操作失败时触发',
    requiredParams: [],
    optionalParams: ['action_code', 'reason_code']
  },
  // 能力解锁里程碑（2026-10-27 补）。此前解锁链路**只有失败侧有埋点**
  // （credit_action_failed），quote 成功 / 用户取消 / execute 成功三者零上报
  // ⇒ 有分母没分子，解锁成功率与 quote→execute 转化率都算不出来。
  // 预算：自有 7（1 必填 + 6 可选）= full 档，峰值 7+5+1 = 13 ≪ 25。
  CAPABILITY_UNLOCK_COMPLETED: {
    name: 'capability_unlock_completed',
    category: 'Billing',
    description: '能力解锁里程碑：报价就绪 / 用户取消 / 解锁成功',
    requiredParams: ['unlock_stage'],
    optionalParams: [
      'feature_code', 'sub_feature_code', 'capability_code', 'subject_id',
      'credits_required', 'request_id'
    ],
    // quote_ready  = 报价成功、确认弹窗已展示（用户已看到真实扣点数）
    // cancelled    = 用户在确认弹窗主动放弃（此前被 credit_action_failed 显式过滤掉，完全不可见）
    // unlocked     = 扣点并授予成功、门禁即将消失（此前完全不可见）
    // dismissed_by_unmount = 弹窗还开着时页面被卸载/刷新/关标签（不会走 cancel，属兜底终态）
    unlockStageValues: ['quote_ready', 'cancelled', 'unlocked', 'dismissed_by_unmount']
  }
});
